import { render } from "./ActivateSwitcher.vue?vue&type=template&id=2dd8bb7c"
import script from "./ActivateSwitcher.vue?vue&type=script&lang=js"
export * from "./ActivateSwitcher.vue?vue&type=script&lang=js"

import "./ActivateSwitcher.vue?vue&type=style&index=0&id=2dd8bb7c&lang=scss"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__